import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';

import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { MatDialog } from '@angular/material/dialog';
import { NgbDateStruct, NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
const _ = require('lodash');

import { SliderModelService } from './../../../../../services/infrastructure/sliderModel.service';
import { ProductAddComponent } from './../../../../../common/components/product-add/product-add.component';
import { BroadcastService } from './../../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../../services/infrastructure/config.service';
import { DashboardFilter } from './../../../../../models/DashboardFilter';
import { GrowerOrderService } from './../../../../../services/seed/growerOrder.service';
import { GrowerOrderItemVM } from './../../../../../models/GrowerOrderItemVM';
import { AddEditOrderDetailComponent } from '../add-edit-order/add-edit-order.component';
import { LocalStorageService } from './../../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../../../common/constants/master-constants';
import { ErrorStateMatcher } from '@angular/material/core';
import { LolLoggerService } from '../../../../../common/shared/lol-logger.service';
import { CommonService } from '../../../../../services/common/common.service';

@Component({
  selector: 'app-grower-order-add',
  templateUrl: './grower-order-add.component.html',
  styleUrls: ['./grower-order-add.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class GrowerOrderAddComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ProductAddComponent, { static: true }) productComponent: ProductAddComponent;
  @ViewChild(AddEditOrderDetailComponent, { static: true }) addEditOrderDetail: AddEditOrderDetailComponent;
  growerOrderObj: any;
  editToolKit = false;
  isSliderAddGrowerSet = false;
  public selectedAccountObj: any;
  public baseUrl;
  public accountList: any;
  growerList: any;
  public productList = new Array();
  public updatedProductList: GrowerOrderItemVM[] = [];
  public dashboardFilter: DashboardFilter;
  public errorMsgs = new Array();
  public currentErrorRow = 0;
  public nextErrorId = 0;
  accountId: any;
  // growerGLN: string;
  growerGMK: number;
  accountEmail: any;
  showErrorBlock = false;
  geuValue: number;
  deliveryDateValue: string;
  isAccountSelected = true;
  columnsToDisplay = ['checkbox', 'product', 'geu', 'conv', 'productline', 'delivery'];
  public headerYear: any;
  public headerCompany = MasterConstants.US_COMPANYCODE;
  public accountLoading: any;
  public growerLoading: any;
  growerListLeft: any;
  CreateNewOrder: any;
  tabNode: string;
  public isNotValidOrder = true;
  title: string;
  message: string;
  subscriptionForCmpReload;
  parentAccountId: any;
  index = 0;
  emailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
  searchCount = 0;
  shortDate: any;
  model: NgbDateStruct;
  date: { year: number, month: number };
  companyCodeSubscription: any;
  growerSliderSubscription: any;
  isDisabled = (date: NgbDate, current: { month: number }) => date.month !== current.month;
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;
  SelectedAccount: number;
  accountsLoading = false;
  productSearchFilter: string;
  isInvalidEmail = false;
  public selectedBillingType: string;
  matcher = new InputErrorStateMatcher(this.isInvalidEmail);
  isSubscriptionAccess = true;
  searchTypeList: any[] = [
    { name: 'Product Name', value: 'productName' },
    { name: 'Marketing Brand', value: 'marketingBrand' },
    { name: 'Seed Size', value: 'seedSize' },
    { name: 'Package Size', value: 'packageSize' },
    { name: 'Technology', value: 'technology' },
    { name: 'Treatment', value: 'treatment' },
    { name: 'Maturity', value: 'maturity' },
    { name: 'Product Line', value: 'productLine' }
  ];

  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  reason = '';
  sellerData: any;
  selectedCount = 0;
  sellerId: any;

  mode = new UntypedFormControl('over');

  constructor(
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private growerOrderService: GrowerOrderService,
    private toastrService: ToastrService,
    public dialog: MatDialog,
    private sliderModelService: SliderModelService,
    private calendar: NgbCalendar,
    private localStorageService: LocalStorageService,
    private commonService: CommonService) {
    this.model = this.calendar.getToday();

    this.subscriptionForCmpReload = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.reInitialiseGrowerAddCmp();
      }
    });

    this.dashboardFilter = new DashboardFilter();
    this.activatedRoute.paramMap.subscribe(params => {
      if (+(params.get('accountNo')) > 0) {
        this.accountId = +(params.get('accountNo'));
        this.parentAccountId = +(params.get('accountNo'));
      }
    });
  }

  ngOnInit() {
    this.productSearchFilter = this.searchTypeList[0].value;
    this.addEditOrderDetail.bindDataSource([], true, true);
    this.addEditOrderDetail.resetProductFilter();
    this.addEditOrderDetail.applyFilterData(this.addEditOrderDetail.productFilters);

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
          this.accountEmail = isActiveUser.emailId;
        } else {
          this.isSubscriptionAccess = true;
        }
      }
    }

    this.getAccountList();

    this.getGrowerListByAccountLeft();
    this.errorMsgs.push({ 'rowId': 1, 'errors': [] });
    this.currentErrorRow = this.errorMsgs[0].errors.length > 0 ? this.errorMsgs[0].rowId : 1;
    this.nextErrorId = this.currentErrorRow;

    this.growerSliderSubscription = this.sliderModelService.gmkValue.subscribe(x => {
      this.isSliderAddGrowerSet = true;
      this.growerGMK = +x;
      this.getGrowerListByAccount(this.selectedAccountObj);
    }, error => { LolLoggerService.error(error); });
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  validateEmail() {
    this.isInvalidEmail = false;
    this.isInvalidEmail = this.commonService.validateEmail(this.accountEmail, true);
    if (this.accountEmail) {
      this.addEditOrderDetail.isInvalidEmail = false;
      if (this.isInvalidEmail) {
        this.addEditOrderDetail.isInvalidEmail = true;
      }
      else {
        if (this.growerOrderObj) {
          this.growerOrderObj.EmailTo = this.accountEmail;
        }
      }
      this.matcher = new InputErrorStateMatcher(this.isInvalidEmail);
    }
  }

  setHeight() {
    const templateHeight = window.innerHeight - $('.search-section').outerHeight() - 76;
    $('.order-view-sec').css('max-height', templateHeight + 'px');

    const GrowerAddSecHeight = window.innerHeight - $('.search-section').outerHeight() - 96;
    $('.order-view-sec .grower-add-sec').css('min-height', GrowerAddSecHeight + 'px');
  }

  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#orderView').scrollTop = 0;
      const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
      $('#orderView').animate({ scrollTop: nextOffset }, 1000);
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#orderView').scrollTop = 0;
      $('#orderView').animate({ scrollTop: 0 }, 1000);
      // var nextOffset = document.getElementById("error_"+this.nextErrorId.toString()).offsetTop;
      // document.getElementById("orderView").scrollTop = nextOffset;
    }
  }

  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  hideCommonError() {
    this.showErrorBlock = false;
  }

  validateDate($event) {
    if ($event.value && $event.value != null) {
      // this.isNotValidOrder = false;
    }
    else {
      // this.isNotValidOrder = true;
    }
  }

  EnableAllEditToolKit(isChecked: boolean) {
    // if (isChecked) {
    //  this.editToolKit = true;
    //  this.growerOrderDS.data.forEach(item => {
    //    item.isSelected = true;
    //  });
    //  this.selectedCount = this.growerOrderDS.data.length;
    // }
    // else {
    //  this.editToolKit = false;
    //  this.growerOrderDS.data.forEach(item => {
    //    item.isSelected = false;
    //  });
    //  this.selectedCount = 0;
    // }
  }

  activeEditToolKit(isChecked: boolean) {
    if (isChecked) {
      this.selectedCount = this.selectedCount + 1;
    }
    else {
      this.selectedCount = this.selectedCount - 1;
    }

    if (this.selectedCount > 0) {
      this.editToolKit = true;
    }
    else {
      this.editToolKit = false;
    }
  }

  geuValueChange(action: string, productItem) {
    // if (action == 'decrease') {
    //  this.growerOrderDS.data.forEach(item => {
    //    item.geu = (item.geu <= 0 ? 0 : item.geu + item.conv);
    //  });
    // }
    // else {
    //  this.growerOrderDS.data.forEach(item => {
    //    item.geu = (item.geu <= 0 ? 0 : item.geu - item.conv);
    //  });
    // }

    this.tabNode = 'edit';
  }

  showDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
  }

  openSliderModel() {
    this.sliderModelService.initializeComponentVal(this.accountId);
    this.sliderModelService.activeSlider('AddProductSlider');
  }

  openGrowerSliderModel() {
    if (this.accountId && this.accountId != 0) {
      this.sliderModelService.initializeComponentVal(this.accountId);
      this.sliderModelService.toAccountNumber.next(this.accountId);
      this.sliderModelService.growerSearchType.next('GOT');
      this.sliderModelService.activeSlider('growerSearchSlider');
    }
    else {
      this.toastrService.warning('Select an Account before adding a Grower.');
    }
  }

  getAccountList() {
    this.growerOrderService.getAccounts().subscribe((result: any) => {
      this.accountList = result.filter(x => x.wfusB2BEnablement == 'No');
      if (this.accountList != undefined) {
        // TODO: Fetch Growers list when AccountId is comming as selelcted from Landing Page //Sumit
        const acc = this.accountList.filter(x => x.accountNumber == this.accountId);
        if (acc[0] != undefined) {
          this.accountId = +acc[0].accountNumber;
          this.selectedBillingType = acc[0].billingAdressType;
          this.getGrowerListByAccount(acc[0]);
        }
      }
    }, error => LolLoggerService.error(error));
  }

  onGrowerSelection($event) {
    if ($event) {
      const obj = {
        growerOrderId: 0,
        growerName: $event.growerName,
        orderID: '',
        growerAddress: $event.address1,
        city: $event.city,
        state: $event.state,
        zipcode: $event.zip,
        lastUpdatedAt: $event.updateTimeStamp,
        accountNo: this.accountId,
        orderType: '',
        // TODO: Sumit - GMK
        gmk: $event.gmk,
        EmailTo: this.accountEmail
      };
      this.growerOrderObj = obj;
      this.growerOrderService.GrowerChange(obj);
      const orderDetail = $event.growerOrderList[0];
      if (orderDetail && orderDetail.growerOrderID) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
        if (this.parentAccountId === undefined || this.parentAccountId === '0') {
          this.router.navigate(['orders/grower-order-detail', 0, orderDetail.growerOrderID]);
        }
        else {
          this.router.navigate(['orders/grower-order-detail', orderDetail.shipToAccount, orderDetail.growerOrderID]);
        }
      }
    }
    else {
      this.growerOrderService.GrowerChange(null);
      this.addEditOrderDetail.enableAddProduct = true;
      this.addEditOrderDetail.disableOnLock = false;
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
    }
    this.resetOrderState();
    this.addEditOrderDetail.bindDataSource([], true, true);
    this.addEditOrderDetail.resetProductFilter();
  }

  resetOrderState() {
    this.productList = [];
    this.isNotValidOrder = true;
    if (this.productComponent) {
      this.resetProductComponent();
      this.productComponent.isAddProductClick = false;
    }
    this.addEditOrderDetail.enableAddProduct = true;
    this.addEditOrderDetail.productSearchFilter = this.addEditOrderDetail.searchTypeList[0].value;
    this.showErrorBlock = false;
    this.errorMsgs = [{ rowId: 1, errors: [] }];
    this.currentErrorRow = 1;
    this.nextErrorId = 1;
    this.editToolKit = false;
    this.selectedCount = 0;
  }

  getGrowerListByAccount(account) {
    if (!this.isSliderAddGrowerSet) {
      this.growerGMK = null;
    }
    this.selectedAccountObj = account;
    if (account) {
      this.selectedBillingType = account.billingAddressType;
      this.broadcastService.broadcast(this.configService.ACCOUNT_CHANGE, { hasAccountSelected: this.selectedBillingType });
      if (this.selectedBillingType in MasterConstants.BILLING_ADDRESS_TYPE) {
        this.accountId = account.accountNumber;
        // this.accountEmail = account.emailAddress;
        this.isAccountSelected = false;

        this.dashboardFilter.cropYear = this.headerYear;
        this.dashboardFilter.shipToAccount = this.accountId;
        const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };
        this.growerOrderService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
          this.growerList = result;
          this.searchCount = this.growerList.length;
          this.growerList.forEach(grower => {
            grower.businessName = (grower.businessName == null || grower.businessName == '' ?
              (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
              (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
              (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
              : grower.businessName);
            grower.OrderNumber = grower.growerOrderList[0] ? grower.growerOrderList[0].orderNumber : '';
            grower.GrowerOrderID = grower.growerOrderList[0] ? grower.growerOrderList[0].GrowerOrderID : 0;
            grower.ShipToAccount = grower.growerOrderList[0] ? grower.growerOrderList[0].ShipToAccount : this.accountId;
            grower.OrderStatus = grower.growerOrderList[0] ? grower.growerOrderList[0].OrderStatus : '';
            grower.EmailTo = this.accountEmail;
          });
          if (this.isSliderAddGrowerSet) {
            const gwrObj = this.growerList.filter(x => x.gmk == this.growerGMK);
            this.onGrowerSelection(gwrObj[0]);
            this.isSliderAddGrowerSet = false;
          }
        }, error => LolLoggerService.error(error));
      }
      else {
        this.resetPreviousData();
        this.accountId = null;
        this.toastrService.warning('Account not eligible for Ordering.');
      }
    }
    else {
      this.resetPreviousData();
    }
    this.addEditOrderDetail.bindDataSource([], true, true);
    this.addEditOrderDetail.resetProductFilter();
  }

  resetPreviousData() {
    if (this.growerList) {
      this.growerList = [];
      this.searchCount = this.growerList.length;
    }
    this.accountEmail = '';
    this.isAccountSelected = true;
    this.productList = [];
    this.isNotValidOrder = true;
    // clear product component
    if (this.productComponent) {
      this.resetProductComponent();
      this.productComponent.isAddProductClick = false;
    }
    this.addEditOrderDetail.enableAddProduct = true;
  }

  growerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf(term) > -1);
  }

  // Serach the data in list and get the serach items count
  search($event) {
    let list: any;
    list = _.filter(this.growerList, item => item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf($event) > -1
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf($event) > -1)
      || (item.growerGMK == null ? false : item.growerGMK.toString().indexOf($event) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf($event) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf($event) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf($event) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf($event) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf($event) > -1));
    this.searchCount = list.length;
  }

  onClose(): void {
    if (this.productComponent) {
      if (this.productComponent.isAddProductClick == true && this.productComponent.selectedProductList.length > 0) {
        this.productComponent.selectedProductList.forEach(x => {
          this.productList.push(x);
        });
        // this.productList = this.productComponent.selectedProductList;
        this.addEditOrderDetail.bindDataSource(this.productList, true, false);
        this.addEditOrderDetail.resetProductFilter();
        this.resetProductComponent();
        this.isNotValidOrder = false;
      }
      // Commented by Sumit Agarwal - 2/6/2019
      // else {
      //  if (this.productComponent.selectedProductList.length > 0) {
      //    //Added Popup
      //    this.title = "Confirmation";
      //    this.message = "You have some unsaved changes.Press OK to save this data.";
      //    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      //      width: '350px',
      //      data: { title: this.title, message: this.message, labelYes: 'Ok', labelNo: 'Cancel' }
      //    });

      //    dialogRef.afterClosed().subscribe(result => {
      //      //If user selected Yes
      //      if (result == true && this.productComponent.selectedProductList.length > 0) {
      //        this.productComponent.selectedProductList.forEach(x => {
      //          this.productList.push(x);
      //        });
      //        //this.productList = this.productComponent.selectedProductList;
      //        this.growerOrderDS = new MatTableDataSource(this.productList);
      //        this.growerOrderDS.paginator = this.paginator;
      //        this.growerOrderDS.filterPredicate = (data, filter): boolean => (data[this.productSearchFilter.toString()].toLowerCase().includes(filter));
      //        this.isNotValidOrder = false;
      //      }
      //      this.resetProductComponent();
      //    });
      //  }
      //  else {
      //    this.isNotValidOrder = true;
      //  }
      // }

      this.productComponent.filterValueList = new Array();
      this.productComponent.productDataSource = new MatTableDataSource([]);
      this.productComponent.isAddProductClick = false;
    }
    // this.sidenav.close();
    this.sliderModelService.close();
  }

  // reset product component
  resetProductComponent() {
    if (this.productComponent) {
      this.productComponent.selectedProductList = new Array();
      this.productComponent.itemList = new Array();
      this.productComponent.filterValueList = new Array();
      this.productComponent.searchValue = '';
      this.productComponent.productList = new Array();
      this.productComponent.productDataSource = new MatTableDataSource([]);
    }
    // this.productComponent.productDataSource.paginator = this.productComponent.productPaginator;
  }

  accountChange($event) {
    if ($event == undefined) {
      this.getGrowerAccount(0);
      return;
    }
    this.getGrowerListByAccountLeft();
  }

  getGrowerAccount(accountNo: number) {
    this.growerOrderService.getGrowerAccount(this.headerYear, accountNo).subscribe(result => {
      this.growerList = result;
      this.searchCount = this.growerList.length;
    }, (error => {
      LolLoggerService.error(error);
    }));
  }

  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  getGrowerListByAccountLeft() {
    if (this.SelectedAccount) {
      this.growerOrderService.getGrowerAccount(this.headerYear, this.SelectedAccount).subscribe(result => {
        this.growerListLeft = result;
      }, error => LolLoggerService.error(error));
    }
  }

  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  // Action for plus icon on GEU
  geuValueIncrement(productItem) {
    productItem.PrimaryQuantity = Number(productItem.PrimaryQuantity) + Number(productItem.conv);
  }

  // Action for minus icon on GEU
  geuValueDecrement(productItem) {
    productItem.PrimaryQuantity = (productItem.PrimaryQuantity <= 0 ? 0 : productItem.PrimaryQuantity - productItem.conv);
  }

  // Reinitialise Grower Cmp on Create new Grower Order button
  reInitialiseGrowerAddCmp() {
    this.productSearchFilter = this.searchTypeList[0].value;
    if (this.parentAccountId != this.accountId) {
      this.accountId = this.parentAccountId;
    }
    this.growerGMK = null;
    this.addEditOrderDetail.bindDataSource([], true, true);
    this.addEditOrderDetail.resetProductFilter();

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }

    // this call was duplicate also called in ngOnInit(); there are no conditions on which it was computed as ngOnInit is called after the constructor finishes.
    // this.getAccountList();
    this.growerGMK = null;
  }

  // Method on every navigationEnd event
  ngOnDestroy() {
    // avoid memory leaks here by cleaning up after ourselves. If we
    // don't then we will continue to run our initialiseGrowerAddCmp()
    if (this.subscriptionForCmpReload) {
      this.subscriptionForCmpReload.unsubscribe();
    }
    if (this.companyCodeSubscription) {
      this.companyCodeSubscription.unsubscribe();
    }

    if (this.growerSliderSubscription) {
      this.growerSliderSubscription.unsubscribe();
    }
  }

  // New functions Added from Edit to Add : Sumit
  sellerSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  GetSellerList() {
    this.growerOrderService.getSellerList(this.accountId).subscribe(result => {
      this.sellerData = result;
    //this.growerOrderService.getSellerList(this.accountId).subscribe((result: any[]) => {
    //  this.sellerData = result?.sort((a, b) => (a?.accountName ?? '').localeCompare(b?.accountName ?? ''));
    }, error => LolLoggerService.error(error));
  }

  SellerChange($event) {
    if ($event != null && $event.accountNumber != null) {
      this.sellerId = $event.accountNumber;
      this.SetAllFields('sellerid', this.sellerId);
    }
  }

  SellerAccountClear($event) {
    this.sellerId = new Number();
  }

  SetAllFields(field: string, value: any) {
    this.tabNode = '';
  }

  enableEditToolKit($event) {
    this.editToolKit = !this.editToolKit;
  }

  revertAllChanges() {
    this.addEditOrderDetail.RevertToPrevious([], false);
    this.hideCommonError();
  }
}
class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
